import { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot, updateDoc } from 'firebase/firestore';
//import { useAuth } from "../../utils/AuthContext/authcontext";
import { db, firestore } from '../firebase/firebase';

export function useFirestoreDoc(path) {
  const [docData, setDocData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const { refreshData, user, userData, logout, login, acceptFriendRequest, removeFriendRequest, searchbyUsersId } = useAuth();

  useEffect(() => {
    
	if(path == undefined) return;
	
	const ref = doc(firestore, path);//doc(db, "users", path);
    const unsub = onSnapshot(ref, snap => {
      if (snap.exists()) {
        setDocData(snap.data());
        setLoading(false);
      } else {
        setError(new Error('Document does not exist.'));
        setLoading(false);
      }
    }, err => {
      setError(err);
      setLoading(false);
    });

    return unsub;
  }, [path]);

  const update = async (fields) => {
    try {
      if(path == undefined) return;
	  const ref = doc(firestore, path);//doc(db, "users", path);
	  await updateDoc(ref, fields);
    } catch (err) {
      setError(err);
    }
  };

  return { docData, loading, error, update };
}
